module.exports = __webpack_public_path__ + "static/lightship-vps-for-web-68cccd2e3ba5462034ffbf09eb76d928.mp4";